interface Window {
	fbq?: any;
	amplitude?: any;
	FB_PIXEL_ID?: string;
	AMPLITUDE_API_KEY?: string;
}

function initAnalytics(email?: string): void {
	if (typeof window.fbq !== 'undefined' && typeof window.FB_PIXEL_ID === 'string') {
		const userProperties = {};
		if (typeof email === 'string') {
			userProperties['em'] = email.toLowerCase();
		}
		window.fbq('init', window.FB_PIXEL_ID, userProperties);
	} else {
		console.warn('FB Pixel is not loaded');
	}

	if (typeof window.amplitude !== 'undefined' && typeof window.AMPLITUDE_API_KEY === 'string') {
		window.amplitude.init(window.AMPLITUDE_API_KEY);
	} else {
		console.warn('Amplitude is not loaded');
	}
}

function extractPixelParameters(obj: {} | null): {} | null {
	if (obj === null) return null;
	let copy = {};
	for (let key in obj) {
		if (obj.hasOwnProperty(key) && isAllowedPixelParameter(key)) {
			copy[key] = obj[key];
		}
	}
	return copy;
}

function isAllowedPixelParameter(paramName: string): boolean {
	const allowedParams = ['content_type', 'content_ids', 'value', 'currency'];
	return allowedParams.includes(paramName);
}

function isAllowedPixelEvent(eventName: string): boolean {
	const allowedEvents = ['PageView', 'ViewContent', 'Lead', 'InitiateCheckout', 'Purchase'];
	return allowedEvents.includes(eventName);
}

function extractAmplitudeParameters(obj: {} | null): {} | null {
	if (obj === null) return null;
	let copy = {};
	for (let key in obj) {
		if (obj.hasOwnProperty(key) && isAllowedAmplitudeParameter(key)) {
			copy[key] = obj[key];
		}
	}
	return copy;
}

function isAllowedAmplitudeParameter(paramName: string): boolean {
	const disallowedParams = ['content_type', 'content_ids'];
	return !disallowedParams.includes(paramName);
}

function isHighPriorityAmplitudeEvent(eventName: string): boolean {
	const highPriorityEvents = ['Lead', 'InitiateCheckout', 'Purchase'];
	return highPriorityEvents.includes(eventName);
}

function trackEvent(name: string, params: {} | null, eventID?: string): void {
	if (typeof window.fbq !== 'undefined' && isAllowedPixelEvent(name)) {
		if (eventID) {
			const paramsForPixel = extractPixelParameters(params);
			window.fbq('track', name, paramsForPixel, { eventID });
		} else {
			console.warn(`${name} event not sent: missing eventID`);
		}
	}

	if (typeof window.amplitude !== 'undefined') {
		const paramsForAmplitude = extractAmplitudeParameters(params);
		window.amplitude.track(name, paramsForAmplitude);

		if (isHighPriorityAmplitudeEvent(name)) {
			window.amplitude.flush();
		}
	}
}

function identifyUser(params: {}): void {
	if (typeof window.amplitude !== 'undefined') {
		const identifyEvent = new window.amplitude.Identify();
		for (const [key, value] of Object.entries(params)) {
			identifyEvent.set(key, value);
		}
		window.amplitude.identify(identifyEvent);
	}
}
